import React, { Fragment } from "react";

export default function Loader(props) {
    const count = props.count || 1;
    return (
        <Fragment>
            {Array.from(Array(count).keys()).map((i) => (
                <div key={i}>
                    <div className="h-6 w-14 animate-pulse rounded bg-gray-300 text-gray-300"></div>
                    <div className="mt-1 h-9 w-full animate-pulse rounded bg-gray-300 text-gray-300"></div>
                </div>
            ))}
        </Fragment>
    );
}
